import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import logo from "../assets/logo.png";

function Navbar({ setMode, mode }) {

  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleApply = () => {
    navigate("/admission#form");
    closeMenu();
  };

  return (
    <div className="navbar">

      {/* LOGO */}
      <div className="logo">
        <img src={logo} alt="logo" />
        <div>
          <h2>
            {mode === "school"
              ? "TEJKIRTI LITTLE STAR"
              : "TEJKIRTI"}
          </h2>
          <h4>
            {mode === "school"
              ? "PRE-SCHOOL"
              : "SENIOR WOMEN’S COLLEGE"}
          </h4>
        </div>
      </div>

      {/* HAMBURGER */}
      <div className="menu-toggle" onClick={toggleMenu}>
        ☰
      </div>

      {/* NAV LINKS */}
      <div className={`nav-links ${menuOpen ? "open" : ""}`}>

        <NavLink to="/" end onClick={closeMenu}>Home</NavLink>

        <NavLink to="/about" onClick={closeMenu}>About</NavLink>

        <NavLink to="/programs" onClick={closeMenu}>
          {mode === "school" ? "Classes" : "Programs"}
        </NavLink>

        {mode === "college" && (
          <NavLink to="/facilities" onClick={closeMenu}>
            Facilities
          </NavLink>
        )}

        <NavLink to="/admission" onClick={closeMenu}>
          Admission
        </NavLink>

        {mode === "college" && (
          <>
            <NavLink to="/fees" onClick={closeMenu}>Fees</NavLink>
            <NavLink to="/faculty" onClick={closeMenu}>Faculty</NavLink>
          </>
        )}

        <NavLink to="/contact" onClick={closeMenu}>
          Contact
        </NavLink>

      </div>

      {/* RIGHT SIDE */}
      <div className="nav-right">

        <button className="nav-btn" onClick={handleApply}>
          Apply Now
        </button>

        <div className="mode-toggle">

          <button
            className={`mode-btn ${mode === "school" ? "active" : ""}`}
            onClick={() => setMode("school")}
          >
            School
          </button>

          <button
            className={`mode-btn ${mode === "college" ? "active" : ""}`}
            onClick={() => setMode("college")}
          >
            College
          </button>

        </div>

      </div>

    </div>
  );
}

export default Navbar;